import { Component, OnInit } from '@angular/core'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'

@Component({
  selector: 'se-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
  standalone: false,
})
export class CreateAccountComponent implements OnInit {

  public footerYear = new Date().getFullYear()
  public logo: string

  constructor(
    private analyticsService: AnalyticsService
  ) {

  }

  public ngOnInit(): void {
    this.logo = `${environment.uiThemes}/assets/latest/images/sportsengine-logo-color-black.svg`
  }

  public trackEvent(action: string): void {
    this.analyticsService.seEvent(action)
  }
}
